import {Artifact} from "../../../../types";
import {PasteChip} from "../../../../components/PasteChip";
import {isPasteArtifact, readPasteChip} from "../../utils/pasteAttachments";

interface UserAttachmentRendererProps {
    artifact: Artifact;
}

/**
 * This is the card for an attachment that the user sent. The answer can refer
 * to the attachment as [aN]. The reference needs a target. This card shows a
 * chip. The chip matches the chip on the user's message. An attachment kind
 * without its own card shows nothing.
 */
export function UserAttachmentRenderer({
    artifact,
}: UserAttachmentRendererProps) {
    if (!isPasteArtifact(artifact)) return null;
    return <PasteChip {...readPasteChip(artifact)} preview />;
}
